import { Autocomplete, Box, Link, TextField, Typography } from "@mui/material";

const locations = [
  {
    name: "Gummersbach",
    placeId: "ChIJw1B-7RG1vkcRHdIoDIyDpww",
  },
  {
    name: "Coburg",
    placeId: "ChIJjZgEFJXNo0cRylkltJfK5pQ",
  },
  {
    name: "Jessen (Elster)",
    placeId: "ChIJH_vgRZfPp0cRtv-UgMRVOLw",
  },
  {
    name: "Pirna",
    placeId: "ChIJP3DAKLK5CUcR92zAw0yNuI0",
  },
  {
    name: "Markranstädt",
    placeId: "ChIJh0eFtvL1pkcRJYP1-7p4zu8",
  },
  {
    name: "Bergen auf Rügen",
    placeId: "ChIJA-drHKdDq0cRcN0XagDhSss",
  },
  {
    name: "Kaufbeuren",
    placeId: "ChIJX6qSB0JrnEcR23ZBacI1ylI",
  },
  {
    name: "Wermelskirchen",
    placeId: "ChIJudfQt7gruUcRrhsIgSs_l4w",
  },
  {
    name: "Wittenberg",
    placeId: "ChIJmf--_sIvpkcREw1nG3Yow3s",
  },
  {
    name: "Großenhain",
    placeId: "ChIJOysgxkMrCEcRj52FPd6smXA",
  },
  {
    name: "Herne",
    placeId: "ChIJxXODAqzhuEcRUklK_oyZ4fQ",
  },
  {
    name: "Bad Lobenstein",
    placeId: "ChIJlVwNU4NBoUcRUSCm3NL5pZ0",
  },
  {
    name: "Bremen",
    placeId: "ChIJa9l_sRMosUcRBrC5wWuqa_8",
  },
  {
    name: "Emden",
    placeId: "ChIJ6c-FV1Y5tkcRmRMGGIzDYHk",
  },
  {
    name: "Rotenburg (Wümme)",
    placeId: "ChIJf4872ucDsUcRlVJ_t4CaE9k",
  },
  {
    name: "Berlin Mariendorf",
    placeId: "ChIJORv0pOqTr0cR578UiqBZtkY",
  },
  {
    name: "Meißen",
    placeId: "ChIJFQoxrc3VCUcRWl6c890X9QY",
  },
  {
    name: "Stade",
    placeId: "ChIJ5U_dcRdlsUcRhfbq7WfYTaE",
  },
  {
    name: "Schönebeck (Elbe)",
    placeId: "ChIJ24VHdGv7pUcRYTulkihI-Pc",
  },
  {
    name: "Bitterfeld-Wolfen",
    placeId: "ChIJyR5SdBhrpkcRVJkvzNNsFKw",
  },
  {
    name: "Weimar",
    placeId: "ChIJX3csWGUbpEcRORRjPZuusfQ",
  },
  {
    name: "Hamburg Deutschkurse",
    placeId: "ChIJXzKH5FuPsUcRK0zyhaRoDok",
  },
  {
    name: "Arnsberg",
    placeId: "ChIJvZfEtHJnuUcRO69f295LYBk",
  },
  {
    name: "Bremervörde",
    placeId: "ChIJo_nh_vdDsUcRBvvloM0NTTs",
  },
  {
    name: "Eilenburg",
    placeId: "ChIJkaa-GKdTpkcRH1pSgp3UUz0",
  },
  {
    name: "Haldensleben",
    placeId: "ChIJ8ZL3X6plr0cR1NiZIrscE5E",
  },
  {
    name: "Vechta",
    placeId: "ChIJ0-5E_J9Jt0cRcnlNEZwkr2Y",
  },
  {
    name: "Wolfsburg",
    placeId: "ChIJb9qFpiaTr0cRje0DzhFIZSs",
  },
  {
    name: "Bad Kreuznach",
    placeId: "ChIJ2y5UJsXxvUcRKij5b9ZZ5Y8",
  },
  {
    name: "Grafenau",
    placeId: "ChIJmfBdwOrndEcREqxCZpAHS-E",
  },
  {
    name: "Olpe",
    placeId: "ChIJiR0niuStvkcRU5cvkNHK0uY",
  },
  {
    name: "Leinefelde-Worbis",
    placeId: "ChIJLSpTyYTppEcRlnp5_fOiWYc",
  },
  {
    name: "Gotha",
    placeId: "ChIJv50ODq57pEcRYJCfZrh3dk4",
  },
  {
    name: "Reutlingen",
    placeId: "ChIJafVG6wrzmUcRJwowsNbDOlI",
  },
  {
    name: "Bedburg",
    placeId: "ChIJ6-kXBoZFv0cRQ0GWAnfI2yA",
  },
  {
    name: "Aurich",
    placeId: "ChIJ4TKu8a9DtkcRysfm-CpsbCc",
  },
  {
    name: "Betzdorf",
    placeId: "ChIJ9eM45LOhvkcRiqAH2LJL3HI",
  },
  {
    name: "Mittweida",
    placeId: "ChIJXeeTil5rp0cReBwKcXs9FrA",
  },
  {
    name: "Lippstadt",
    placeId: "ChIJ5c49bEbTu0cRu955Ue7e_Ms",
  },
  {
    name: "Detmold",
    placeId: "ChIJB7Oyb9hFukcRTM4p97gbPs0",
  },
  {
    name: "Worms",
    placeId: "ChIJD5bR1LUtlkcRtibtjkB3Bxs",
  },
  {
    name: "Wetzlar",
    placeId: "ChIJqRG_AuxbvEcRXkhQqVc3qS4",
  },
  {
    name: "Velbert",
    placeId: "ChIJUWLt8bXbuEcR6LLd1t3txE4",
  },
  {
    name: "Limburg",
    placeId: "ChIJ8wDCm53NvUcRSIAFQJayYbo",
  },
  {
    name: "Cham",
    placeId: "ChIJ37-lvVxXdUcRSMylrcTDMuM",
  },
  {
    name: "Halle (Saale) Integrationszentrum",
    placeId: "ChIJG3gPrT9jpkcRTwtbheDnIis",
  },
  {
    name: "Langenfeld",
    placeId: "ChIJbXUxOY0tv0cR6czFP-f3n3s",
  },
  {
    name: "Papenburg",
    placeId: "ChIJEbM_nZuzt0cRU7VI4FcMMrw",
  },
  {
    name: "Pirmasens",
    placeId: "ChIJLVBU8u17lkcRwo6M93TgRko",
  },
  {
    name: "Leverkusen",
    placeId: "ChIJhW6ph0Itv0cRo-H5GcNWjpY",
  },
  {
    name: "Rheine",
    placeId: "ChIJ2aQYPj0zuEcRi8ndb8jicEE",
  },
  {
    name: "Bocholt",
    placeId: "ChIJ7RncEM19uEcRlhKl7wG1Too",
  },
  {
    name: "Winterberg",
    placeId: "ChIJu7mHzzeNu0cRiNkbaBta57g",
  },
  {
    name: "Gladbeck",
    placeId: "ChIJNQolyl3vuEcR8yl7DMc-hUk",
  },
  {
    name: "Rheda-Wiedenbrück",
    placeId: "ChIJr3afM84pukcR_oCtY5yIHMg",
  },
  {
    name: "Gießen",
    placeId: "ChIJHSFyYB1ZvEcR1sJ2xHiDWYE",
  },
  {
    name: "Ahrensburg",
    placeId: "ChIJEyA_NQIfskcRARrxO2yItok",
  },
  {
    name: "Neustrelitz",
    placeId: "ChIJ6d7_Ug9hqUcR8zReed9cETw",
  },
  {
    name: "Winsen (Luhe)",
    placeId: "ChIJLXQ5_k7rsUcRr7fvIYryShs",
  },
  {
    name: "Neuss",
    placeId: "ChIJla0BeUO1uEcRvMmHLEywt-s",
  },
  {
    name: "Gütersloh",
    placeId: "ChIJHUO45RglukcRPrB5sB4rzvc",
  },
  {
    name: "Nordhorn",
    placeId: "ChIJL7Kwkb4huEcRlOvtpWwlSSk",
  },
  {
    name: "Offenburg",
    placeId: "ChIJU6cGLjLTlkcRR-Fv_jVA4is",
  },
  {
    name: "Varel",
    placeId: "ChIJqfiTugzrtkcREdEB9Ja-vik",
  },
  {
    name: "Lübben",
    placeId: "ChIJI503Hhb_B0cRx9sQyFaZ8xg",
  },
  {
    name: "Montabaur",
    placeId: "ChIJJXxE5Nzdv0cR80i0GzNQUts",
  },
  {
    name: "Horbruch",
    placeId: "ChIJHTFacDgjvkcRkPPH-hhCAlE",
  },
  {
    name: "Weilheim",
    placeId: "ChIJ7YEnhJO1nUcRL8mE9oznEdk",
  },
  {
    name: "Bruchsal",
    placeId: "ChIJV_I5ESKhl0cRnzXsKC0rP4I",
  },
  {
    name: "Leipzig West",
    placeId: "ChIJKbO9anX3pkcRk1shT-9f1nI",
  },
  {
    name: "Deggendorf",
    placeId: "ChIJ0d_tqQoRdUcRbcnVbtImMcg",
  },
  {
    name: "Amberg",
    placeId: "ChIJM6O-GxgqoEcR73gv58cK0KE",
  },
  {
    name: "Berlin Reinickendorf",
    placeId: "ChIJvQT6A-lTqEcRDDwdCyU8-WQ",
  },
  {
    name: "Borna",
    placeId: "ChIJ1cX8lXLipkcRJFltvglXt6Y",
  },
  {
    name: "Goslar",
    placeId: "ChIJ7WSzpr9ApUcR8khqNekIwM8",
  },
  {
    name: "Chemnitz",
    placeId: "ChIJtYhsIlhGp0cR7IA91sUnjfw",
  },
  {
    name: "Neumünster",
    placeId: "ChIJA7VZdMlLskcRmWCFNdG9khg",
  },
  {
    name: "Ratingen",
    placeId: "ChIJA3IRT7bIuEcRHMf-BozGDc4",
  },
  {
    name: "Bochum",
    placeId: "ChIJYX76cBbguEcRxf2UsoPvvos",
  },
  {
    name: "Aschaffenburg",
    placeId: "ChIJZex_mhJIvUcRqj2o4EBTbsY",
  },
  {
    name: "Hamburg Mitte",
    placeId: "ChIJM6uptRGPsUcRcCh-czLG5xc",
  },
  {
    name: "Kempten (Allgäu)",
    placeId: "ChIJJUS1CBJ5nEcRXesEAGd5urs",
  },
  {
    name: "KönigsWusterhausen",
    placeId: "ChIJ52NIQ1k-qEcR_L0BUdNVkto",
  },
  {
    name: "Berlin Hellersdorf",
    placeId: "ChIJq4eIVDRKqEcR-uuExBFtSpQ",
  },
  {
    name: "Bremerhaven",
    placeId: "ChIJRcUejD6xtkcR1Ep7DHpRrpI",
  },
  {
    name: "Siegburg",
    placeId: "ChIJCSxFuIjdvkcR24Y6MaLTMxw",
  },
  {
    name: "Delmenhorst",
    placeId: "ChIJfx3LmAzVsEcRHmKEndVxdQI",
  },
  {
    name: "HamburgSüd",
    placeId: "ChIJS0fbsZKOsUcRTixbqKLeTNw",
  },
  {
    name: "Lübeck",
    placeId: "ChIJB7PyQKoOskcRkmWVNlQLqz8",
  },
  {
    name: "Berlin Mitte",
    placeId: "ChIJ5VSYQsNRqEcRf0aG18bnkB4",
  },
  {
    name: "Koblenz",
    placeId: "ChIJUccV4UtjvkcR4fbQHpR_xP0",
  },
  {
    name: "Elmshorn",
    placeId: "ChIJKVRGfDnUs0cRGcIaTasexY4",
  },
  {
    name: "Hoyerswerda",
    placeId: "ChIJjZ9Me01CCEcRJboI4rUaNBs",
  },
  {
    name: "Lüneburg",
    placeId: "ChIJnRPCidndsUcRHTX1c-4IbeI",
  },
  {
    name: "Husum",
    placeId: "ChIJj-Kpq9F_s0cRB-afTvs5ZLc",
  },
  {
    name: "Ueckermünde",
    placeId: "ChIJo-mZUZxFqkcRcasql01pcgM",
  },
  {
    name: "Bamberg",
    placeId: "ChIJ8ZSxGqQjokcRFS05uIQPQj0",
  },
  {
    name: "Freiburg",
    placeId: "ChIJIVZEfWIbkUcRsGeZjQJKlyo",
  },
  {
    name: "Berlin Adlershof",
    placeId: "ChIJfxnGbi5GqEcRm1l5TfVNTwI",
  },
  {
    name: "Duisburg",
    placeId: "ChIJ_3I1AxO_uEcRwXm_uhq4EbE",
  },
  {
    name: "Augsburg",
    placeId: "ChIJ2_S9d029nkcRAg2HSEkaJGo",
  },
  {
    name: "Dresden Nord",
    placeId: "ChIJ-RixjhDMCUcRp1NtHuMpfEU",
  },
  {
    name: "Remscheid",
    placeId: "ChIJeW4vNFIquUcR_HN4yxTQWsY",
  },
  {
    name: "Bautzen",
    placeId: "ChIJbR94h4ZVCEcRc4r_4ClP00k",
  },
  {
    name: "Hanau",
    placeId: "ChIJK6viZfwWvUcR0ZssOobYvYk",
  },
  {
    name: "Merseburg",
    placeId: "ChIJCQ-soBeJpkcR56dZ3HfyMVU",
  },
  {
    name: "Recklinghausen",
    placeId: "ChIJY54MTz_juEcREpOX85SABlU",
  },
  {
    name: "Ulm",
    placeId: "ChIJYbtZ7TlkmUcRNYWu7L6oDfo",
  },
  {
    name: "Wesel",
    placeId: "ChIJnyc01k-FuEcRHhddlKT7TzQ",
  },
  {
    name: "Heilbronn",
    placeId: "ChIJ3Scveh8vmEcRfgZS9xVYI_M",
  },
  {
    name: "Freiberg",
    placeId: "ChIJPdzZnQLgCUcR-Cz2JNMo84k",
  },
  {
    name: "Diepholz",
    placeId: "ChIJTfnuYLlNt0cRtoxYkckoOWU",
  },
  {
    name: "Bonn",
    placeId: "ChIJe2P0ssbhvkcR8_rQ6DNWDVs",
  },
  {
    name: "Grimma",
    placeId: "ChIJkf7UES8Ep0cRGm8tuNTs9y4",
  },
  {
    name: "Zwickau",
    placeId: "ChIJUe7b_Ecsp0cRS0RLiJ95cs8",
  },
  {
    name: "Osnabrück",
    placeId: "ChIJQSPtdJ7luUcRvtgJ_2DJIdw",
  },
  {
    name: "Hof",
    placeId: "ChIJb5Njr_8ZoUcRNpCtfLZZe-U",
  },
  {
    name: "Minden",
    placeId: "ChIJ-6jL0LF2ukcRNmMJtDFNMx0",
  },
  {
    name: "Darmstadt",
    placeId: "ChIJrx1beX5wvUcRkBspSXQjfFU",
  },
  {
    name: "Jena",
    placeId: "ChIJW16Ud72opkcRuSHG0EmITJI",
  },
  {
    name: "Krefeld",
    placeId: "ChIJScoUMQGwuEcRLsBD4Qle86s",
  },
  {
    name: "Hamm",
    placeId: "ChIJ8YQu7gp0uUcRbiVNFPJvKwo",
  },
  {
    name: "Paderborn",
    placeId: "ChIJMyJUN1Ozu0cRIvDYYubvFzo",
  },
  {
    name: "Delitzsch",
    placeId: "ChIJ8-C7OllbpkcRomQlnWoX9D8",
  },
  {
    name: "Kiel",
    placeId: "ChIJZzq6Y4xWskcR79Musp44ymU",
  },
  {
    name: "Karlsruhe",
    placeId: "ChIJNbzOvVAGl0cRumB2gqvSDbs",
  },
  {
    name: "Passau",
    placeId: "ChIJa7YEKJtYdEcRv0bncT99qso",
  },
  {
    name: "Lörrach",
    placeId: "ChIJVcFLHZSwkUcRCqaonKhOlo0",
  },
  {
    name: "Leipzig Süd",
    placeId: "ChIJWbxY3Ar3pkcR3xqkCvLqjKQ",
  },
  {
    name: "Mainz",
    placeId: "ChIJDTYeeuSWvUcRSmKE8dH-sLc",
  },
  {
    name: "Leipzig Mitte",
    placeId: "ChIJ5Q2g-CL4pkcRxFBf9D-uJes",
  },
  {
    name: "Villingen-Schwenningen",
    placeId: "ChIJrUxnS3SWkEcR9JTDWoGlMqY",
  },
  {
    name: "Naumburg (Saale)",
    placeId: "ChIJdbQQC1-XpkcR2y0lqFRrvQg",
  },
  {
    name: "Gera",
    placeId: "ChIJI4Tvjm_PpkcRdysKXuObudc",
  },
  {
    name: "Heidelberg",
    placeId: "ChIJjbGxUcDGl0cRT4Vl-MJdrC8",
  },
  {
    name: "Fulda",
    placeId: "ChIJGzmqD2I2o0cRkKmp_B-2_yQ",
  },
  {
    name: "Berlin PrenzlauerBerg",
    placeId: "ChIJmYfScwdSqEcRP48r2Fs5d-8",
  },
  {
    name: "Münster",
    placeId: "ChIJP4C3btq6uUcR6wRX9iZaA1s",
  },
  {
    name: "Göttingen",
    placeId: "ChIJ4Y5pwBcru0cRKbfRWAzUYA8",
  },
  {
    name: "Magdeburg",
    placeId: "ChIJs6wKgDZfr0cRH8QMSQks4Ok",
  },
  {
    name: "Greifswald",
    placeId: "ChIJpRnQxwJ1q0cRQpkMriESyCI",
  },
  {
    name: "Kaiserslautern",
    placeId: "ChIJi9_3mRsTlkcROFqIE5vC7FU",
  },
  {
    name: "Kassel",
    placeId: "ChIJuepAtDcru0cRmozSwOnf5dg",
  },
  {
    name: "Rostock",
    placeId: "ChIJcRXfklVXrEcR4oUNeqQui9w",
  },
  {
    name: "Ludwigshafen am Rhein",
    placeId: "ChIJn2xlqGvMl0cRR3og_VidRtw",
  },
  {
    name: "Düsseldorf",
    placeId: "ChIJn76xizvKuEcRukNYWKFjHVg",
  },
  {
    name: "Sangerhausen",
    placeId: "ChIJo4-FVTM1pEcRW3Yv-ZKwRiI",
  },
  {
    name: "Köln City",
    placeId: "ChIJXaSK47Elv0cRPm4BvpqarQk",
  },
  {
    name: "Riesa",
    placeId: "ChIJw3wroNWCp0cRWHhM5b641fU",
  },
  {
    name: "Landau in der Pfalz",
    placeId: "ChIJKXyfbvlQlkcR-mXSTXoajz0",
  },
  {
    name: "Schweinfurt",
    placeId: "ChIJGfrDkXv3okcRB-zYd7e1Uug",
  },
  {
    name: "Güstrow",
    placeId: "ChIJH9-4rnw_rEcRAj0-quQFq9E",
  },
  {
    name: "Soltau",
    placeId: "ChIJJfS5KFGzsUcRqJnf4UUu35o",
  },
  {
    name: "Hagen City",
    placeId: "ChIJxe17mGI7uUcRRz-P24P5aSk",
  },
  {
    name: "Bergisch Gladbach",
    placeId: "ChIJpzNvINzXvkcRGwDXKCJO1BA",
  },
  {
    name: "Berlin Wilmersdorf",
    placeId: "ChIJVVUVaItQqEcRgAWuRkudBtQ",
  },
  {
    name: "Saalfeld/Saale",
    placeId: "ChIJv7exFHv9o0cRZ5dtdF29wAo",
  },
  {
    name: "Parchim",
    placeId: "ChIJXZaoCEaDrkcRX_eOAPWMv4w",
  },
  {
    name: "Schwerin",
    placeId: "ChIJ603DkDnYrUcRyPXXGhLyDeI",
  },
  {
    name: "Cuxhaven",
    placeId: "ChIJ2fL8SAwEtEcRgiTkk-i_jVs",
  },
  {
    name: "Nürnberg",
    placeId: "ChIJj3jQh6hXn0cRlbj9Azap90A",
  },
  {
    name: "Eschwege",
    placeId: "ChIJTdoDy-q5pEcRa7j-P2rbi-E",
  },
  {
    name: "Oldenburg",
    placeId: "ChIJxXrBXQTftkcRLV5Wo3G1Puk",
  },
  {
    name: "Solingen",
    placeId: "ChIJq98sbB_TuEcRVxpVTAv4LxM",
  },
  {
    name: "Siegen",
    placeId: "ChIJmRZXZywDvEcRgjj0hfKoFOc",
  },
  {
    name: "Braunschweig",
    placeId: "ChIJR7Sq4LAMsEcROdFpbtQGZmg",
  },
  {
    name: "Hannover",
    placeId: "ChIJezPD17AMsEcR6dhaGsKHk4I",
  },
  {
    name: "Berlin Spandau",
    placeId: "ChIJhcdsxTVWqEcRrK4yO4EuNqA",
  },
  {
    name: "Hildesheim",
    placeId: "ChIJYWBoJamvukcRsreRqzOP-r8",
  },
  {
    name: "Marktredwitz",
    placeId: "ChIJ_8yh2OtVoEcRGbiPhrR2DC8",
  },
  {
    name: "Wismar",
    placeId: "ChIJqYPKQ324rUcRrLN6QwsqckE",
  },
  {
    name: "Saarbrücken",
    placeId: "ChIJbQblqAK0lUcRzjJWxz6IrC4",
  },
  {
    name: "Lingen (Ems)",
    placeId: "ChIJBfQpA0KGt0cR_qpOPf-26jw",
  },
  {
    name: "Mainburg",
    placeId: "ChIJEw8mPSdJnkcRoyg0fxtr4y8",
  },
  {
    name: "Stendal",
    placeId: "ChIJp2obyF47r0cRg0EBsgX5CeQ",
  },
  {
    name: "Weißwasser/Oberlausitz",
    placeId: "ChIJeU1YE0OKCEcRyA3wibnvpq8",
  },
  {
    name: "Meschede",
    placeId: "ChIJAdu0Eivmu0cRX1SP75nKRrs",
  },
  {
    name: "Salzgitter",
    placeId: "ChIJ_UsFDsZQpUcRdv3Q3CFSACo",
  },
  {
    name: "Görlitz",
    placeId: "ChIJKf0T8C_cCEcRu45HK2TkyQg",
  },
  {
    name: "Würzburg",
    placeId: "ChIJadniItSRokcRgG92uJg83bQ",
  },
  {
    name: "Traunstein",
    placeId: "ChIJS3bYXdd6dkcR89tY0Jg7VZI",
  },
  {
    name: "Bayreuth",
    placeId: "ChIJWT9hwsSioUcRBmv3CnXtDgE",
  },
  {
    name: "Weideninder Oberpfalz",
    placeId: "ChIJZXi_sfo4oEcRbUG9qUk3gHI",
  },
  {
    name: "Wuppertal",
    placeId: "ChIJO1_yJrPXuEcRa9-K-a2Nauk",
  },
  {
    name: "Waren (Müritz)",
    placeId: "ChIJG0EfaZ_4q0cR-uEnVPcHbkk",
  },
  {
    name: "Suhl",
    placeId: "ChIJmWQB6gCao0cRu08edsFYJUY",
  },
  {
    name: "Zittau",
    placeId: "ChIJq33j8Eg9CUcRLsqk0rB_pQc",
  },
  {
    name: "Wiesbaden",
    placeId: "ChIJ1ewqlvqVvUcRXaBkLEh-N00",
  },
  {
    name: "SchwäbischGmünd",
    placeId: "ChIJ4RLNYXGomUcRylqohANrN08",
  },
  {
    name: "Nordhausen",
    placeId: "ChIJuZAzvNH_pEcRrhkAEPL5CTQ",
  },
  {
    name: "Annaberg-Buchholz",
    placeId: "ChIJqY3a3AKtoEcRKVSXKQtH-X4",
  },
  {
    name: "Flensburg",
    placeId: "ChIJXYblxidos0cRj8MD1vBpmqI",
  },
  {
    name: "Trier",
    placeId: "ChIJ8eirSY98lUcRdkvo3U55q0A",
  },
  {
    name: "Stralsund",
    placeId: "ChIJFQuV-8ljq0cRryTZC03-ZNY",
  },
  {
    name: "Torgau",
    placeId: "ChIJwUFTLYC5p0cRCsMqvl6vkJw",
  },
  {
    name: "Landshut",
    placeId: "ChIJ78qlDXMmnkcRMY1VQ6lvZIk",
  },
  {
    name: "Frankfurt am Main",
    placeId: "ChIJeRobZlUJvUcR9d7OfyQC8zY",
  },
  {
    name: "Berlin Friedrichshain",
    placeId: "ChIJ18HcwYpOqEcRYRfuBwPcXY4",
  },
  {
    name: "Eberswalde",
    placeId: "ChIJdxV3O8-4qUcRqxlnwrl9IhI",
  },
  {
    name: "OffenbachamMain",
    placeId: "ChIJVw3bSgQOvUcRGLxeL8VEApc",
  },
  {
    name: "Altenburg",
    placeId: "ChIJh4ZKSvLfpkcRTLtG3LvsV0I",
  },
  {
    name: "Chemnitz Altchemnitz",
    placeId: "ChIJWfRsIlhGp0cR_Mp6ArsjY8g",
  },
  {
    name: "Oldenburg Ritterstraße",
    placeId: "ChIJ1SSi0AXftkcRvfT1gu1l7HU",
  },
  {
    name: "Plauen Haselbrunn",
    placeId: "ChIJr3Mfc3omoUcRVy5PkyJklLU",
  },
  {
    name: "Leipzig Plagwitz",
    placeId: "ChIJA_YYVyL4pkcRgfyoCVhdnWs",
  },
  {
    name: "Hamm Südring",
    placeId: "ChIJr4Mu7gp0uUcRz97xUKmXln0",
  },
  {
    name: "Dresden Mitte",
    placeId: "ChIJ7XkNq43PCUcRKKCU0p3WyTs",
  },
  {
    name: "Troisdorf",
    placeId: "ChIJBS12-FnfvkcRSnK-mPjBo4o",
  },
  {
    name: "Burg (bei Magdeburg)",
    placeId: "ChIJIWz1m2JRr0cR-76OJelPw9w",
  },
  {
    name: "Herford",
    placeId: "ChIJwRwiaqsVukcR75Dz21ZTb6s",
  },
  {
    name: "Berlin Moabit",
    placeId: "ChIJm1nGzvFRqEcRHN2tmAEP-rU",
  },
  {
    name: "Mühldorf am Inn",
    placeId: "ChIJOVYB66jpdUcRpq7cejaD7IY",
  },
  {
    name: "Halberstadt",
    placeId: "ChIJPxgbMOaepUcRQ4DZZ6TW8c0",
  },
  {
    name: "Hückeswagen",
    placeId: "ChIJi1ZsExMtuUcRYppMgLq6FjU",
  },
  {
    name: "Aue",
    placeId: "ChIJYZho8D_KoEcRoxU3YWe4D04",
  },
  {
    name: "Prenzlau",
    placeId: "ChIJlSsLp_EmqkcRMzyYaDL2DSI",
  },
  {
    name: "Neubrandenburg",
    placeId: "ChIJF4h_Q3HDq0cRDQYsctrnLyw",
  },
  {
    name: "Essen",
    placeId: "ChIJkZ3A2MvCuEcRPF1YNnY6GDY",
  },
  {
    name: "Erfurt",
    placeId: "ChIJaePbJ79ypEcRBmpHlXklGRY",
  },
  {
    name: "Norderstedt",
    placeId: "ChIJUY7pt3goskcRUfCvXfhjlF8",
  },
  {
    name: "Celle",
    placeId: "ChIJi-WFd3QjsEcR7OA38MqVwlc",
  },
  {
    name: "Dortmund City",
    placeId: "ChIJ85duVd0WuUcR8TTEwmW7QvM",
  },
  {
    name: "Eisenach",
    placeId: "ChIJoyuLOXmbpEcRln0B3XPQiIc",
  },
  {
    name: "Bielefeld",
    placeId: "ChIJU8T3Exc9ukcR2y11Y2ETjWg",
  },
  {
    name: "Ravensburg",
    placeId: "ChIJRZiyr92um0cR_6Q6YpYEI_E",
  },
  {
    name: "Aachen",
    placeId: "ChIJBa376mKZwEcRhoC0GcXzEjE",
  },
  {
    name: "Frankfurt (Oder)",
    placeId: "ChIJE2eLOGuYB0cRr_Q048DSGM4",
  },
  {
    name: "Bad Liebenwerda",
    placeId: "ChIJVZ2DlgaSp0cRP6yRp08tQdM",
  },
  {
    name: "Cottbus",
    placeId: "ChIJiYVlFWx0CEcR0bK0snAWDLU",
  },
  {
    name: "Oranienburg",
    placeId: "ChIJyY4Am2kHqUcRJsa7LRxIyn4",
  },
  {
    name: "Lüdenscheid",
    placeId: "ChIJ4-PJUcpJuUcR74HiQN9VNl4",
  },
  {
    name: "Marburg",
    placeId: "ChIJw3qZhwtivEcRoAZj9tEzkLY",
  },
  {
    name: "Neuruppin",
    placeId: "ChIJT6XSsa49qUcR0eKyEdhxuVo",
  },
  {
    name: "Wilhelmshaven",
    placeId: "ChIJ_7Uf-72TtkcRP9W78WHGlgY",
  },
  {
    name: "Bernburg (Saale)",
    placeId: "ChIJZ52JJsrgpUcROdJH8BoxKiQ",
  },
  {
    name: "Ansbach",
    placeId: "ChIJFXa4es27mEcRcOSPapuVAhw",
  },
  {
    name: "München",
    placeId: "ChIJoWZJXPx1nkcRZjQX5X2YtNA",
  },
  {
    name: "Senftenberg",
    placeId: "ChIJI0Lm2wAWCEcRcieKDySDEhg",
  },
  {
    name: "Dessau-Roßlau",
    placeId: "ChIJAbs_tc4WpkcRY-ZMzX-c9iQ",
  },
  {
    name: "Dresden Süd",
    placeId: "ChIJwyQJSgnGCUcRMFklSZjU8Tc",
  },
  {
    name: "Ingolstadt",
    placeId: "ChIJax0yQU7-nkcRjwUqTpmp-sU",
  },
  {
    name: "Mönchengladbach",
    placeId: "ChIJkT3UJ5GsuEcRER67aPAzOLk",
  },
  {
    name: "Mannheim",
    placeId: "ChIJh3WPrabOl0cR7V1Zkxmg_e8",
  },
  {
    name: "Konstanz",
    placeId: "ChIJW9X4TfT2mkcRtpragei9qdo",
  },
  {
    name: "Stuttgart",
    placeId: "ChIJD4R94UjbmUcRChnjmUCC2XA",
  },
  {
    name: "Plauen",
    placeId: "ChIJKTMDhIwmoUcR8hL44TmoPpw",
  },
  {
    name: "Regensburg",
    placeId: "ChIJUVDnOJnBn0cRi_N_pRWDHMM",
  },
  {
    name: "Potsdam",
    placeId: "ChIJB-3ITxFfqEcRTTBfCXD9iqo",
  },
  {
    name: "Düren Birkesdorf",
    placeId: "ChIJU2LyFxZpv0cReGBeoRuMNAI",
  },
  {
    name: "Finsterwalde",
    placeId: "ChIJAe5JPYofCEcRwJdjyBk2S98",
  },
  {
    name: "Pforzheim",
    placeId: "ChIJRyFBd7Fzl0cREUxqLXs_GEI",
  },
  {
    name: "Oberhausen",
    placeId: "ChIJ_xBSYnDquEcRKsYblD7iag0",
  },
  {
    name: "Kerpen",
    placeId: "ChIJrx2aeUs_v0cRzK6BIEut2Ro",
  },
  {
    name: "Berlin Tempelhof",
    placeId: "ChIJIWLm0aJFqEcRskRkKErimGI",
  },
  {
    name: "Döbeln",
    placeId: "ChIJL6Etji5xp0cRetzgc0arGc4",
  },
  {
    name: "Salzwedel",
    placeId: "ChIJSYlQXuatr0cR845efTOaUXI",
  },
  {
    name: "Halle (Saale)",
    placeId: "ChIJO7Pv1EVjpkcRMiRGgWXahBY",
  },
  {
    name: "Unna",
    placeId: "ChIJ25thmXdtuUcRd7VwkQ_imkU",
  },
  {
    name: "Strausberg",
    placeId: "ChIJQbTzEOkzqEcRJr6SVv94exM",
  },
  {
    name: "Marienberg",
    placeId: "ChIJYd6goAJVp0cRkjpsFWhZz4g",
  },
  {
    name: "Berlin Schöneweide",
    placeId: "ChIJmRXPzOxJqEcRiutCnjcJLVo",
  },
  {
    name: "Memmingen",
    placeId: "ChIJPzcPMAzzm0cR7wG0UgMw-v8",
  },
  {
    name: "LandsbergamLech",
    placeId: "ChIJJ3tvcS8jnEcRO0DWGJ5S6no",
  },
  {
    name: "Rosenheim",
    placeId: "ChIJDbgEb3cbdkcRN8kk4_9fw-I",
  },
  {
    name: "Alfeld (Leine)",
    placeId: "ChIJLzq4I525ukcRbnGSlcylt0k",
  },
  {
    name: "Cloppenburg",
    placeId: "ChIJF7OG5cIVt0cRFDqsni9GHLw",
  },
  {
    name: "Singen",
    placeId: "ChIJC5MzYyl9mkcRBYdLCYIPgRs",
  },
  {
    name: "Mühlhausen",
    placeId: "ChIJlWFP-DGNpEcRcqsykACuFWs",
  },
  {
    name: "St.Wendel",
    placeId: "ChIJp6guIbDBlUcRfL-F3PQoNyw",
  },
  {
    name: "Euskirchen",
    placeId: "ChIJb8NPJUoPv0cRQklbra9sRUY",
  },
  {
    name: "Iserlohn",
    placeId: "ChIJGwRfEAdBuUcRqnOTNRogJ-Y",
  },
  {
    name: "Freising",
    placeId: "ChIJaWJIrpRrnkcRRXsLaqwybpU",
  },
  {
    name: "Wolgast",
    placeId: "ChIJbRlagLkHq0cR7GpWIx0d4X8",
  },
  {
    name: "Limbach-Oberfrohna",
    placeId: "ChIJcehDOVM5p0cR_bcSZwDDiOo",
  },
  {
    name: "Beckum",
    placeId: "ChIJ24y1I9qDuUcRhPTXyU7BNIA",
  },
  {
    name: "Ibbenbüren",
    placeId: "ChIJLfjUbIzFuUcR-wXVrIoJ2fM",
  },
  {
    name: "KölnPorz",
    placeId: "ChIJGRyS0Xcnv0cRgeg79Zy1gzw",
  },
  {
    name: "Tutzing",
    placeId: "ChIJezflJYnJnUcRAU6AGFbStZw",
  },
  {
    name: "Hagen2",
    placeId: "ChIJG4ssuzYluUcR-KQVJXhAZ5I",
  },
  {
    name: "Markkleeberg",
    placeId: "ChIJLdaFFqr7pkcR6---4SBrJU8",
  },
  {
    name: "Witten",
    placeId: "ChIJwyCtBD8huUcR3vBCC4rYOyM",
  },
  {
    name: "Hermeskeil",
    placeId: "ChIJW65eYvmFlUcRDSSSAv0nAdc",
  },
  {
    name: "Reichenbach",
    placeId: "ChIJFXmMbkjVoEcRPpnAhl6lPjg",
  },
  {
    name: "Leer (Ostfriesland)",
    placeId: "ChIJ1aGyBLpNtkcRrrw5H3dU4tY",
  },
  {
    name: "Wuppertal Oberbarmen",
    placeId: "ChIJO3LdZDMpuUcRYR2rnRzTrWI",
  },
];

console.log(locations.length);

const RateViaOtherChannels = (): React.JSX.Element => (
  <Box sx={{ pt: 6 }}>
    <Typography
      variant="h6"
      color="initial"
      sx={{
        mb: 1,
        fontWeight: "bold",
        color: (theme) => theme.palette.primary.main,
        textAlign: { xs: "center", sm: "left" },
      }}
    >
      Noch ein Wunsch
    </Typography>

    <Typography
      variant="body1"
      color="initial"
      sx={{
        textAlign: { xs: "center", sm: "left" },
      }}
    >
      Wenn du mit dem Coaching zufrieden warst, freuen wir uns auch über eine
      Bewertung auf unserer Webseite:
      <br />
      <Link
        href="https://www.wbstraining.de/bewerten/"
        target="_blank"
        rel="noopener noreferrer"
        color="primary"
        underline="hover"
      >
        👉 www.wbstraining.de/bewerten
      </Link>
      <br />
      <br />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: "left",
        }}
      >
        oder auch auf{" "}
        <Autocomplete
          size="small"
          disablePortal
          options={locations
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((location) => ({
              label: location.name,
              value: location.placeId,
            }))}
          groupBy={(option) => option.label.charAt(0).toUpperCase()}
          getOptionLabel={(option) => option.label}
          onChange={(_event, value) => {
            if (value && value.value) {
              window.open(
                `https://search.google.com/local/writereview?placeid=${value.value}`,
                "_blank"
              );
            }
          }}
          sx={{
            width: 200,
            mx: 1,
          }}
          renderInput={(params) => (
            <TextField {...params} label="Google Standort" />
          )}
        />
        oder{" "}
        <Link
          sx={{ ml: 1 }}
          href="https://de.trustpilot.com/review/wbstraining.de"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          underline="hover"
        >
          Trustpilot.
        </Link>
      </Box>
    </Typography>
  </Box>
);

export default RateViaOtherChannels;
